module.exports = __webpack_public_path__ + "static/img/youtube_icon.93cee08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/youtube_icon.png
// module id = 1DKG
// module chunks = 0